import { IAnalyticsEventWorkspace, IAnalyticsWorkspaceArgument } from './types';
import { getWorkspaceEventProperties } from './utils';

export const workspaceCreated = (
  workspace: IAnalyticsWorkspaceArgument,
): IAnalyticsEventWorkspace => {
  return {
    eventName: 'Workspace Created',
    ...getWorkspaceEventProperties(workspace),
  };
};

export const workspaceUpdated = (
  workspace: IAnalyticsWorkspaceArgument,
): IAnalyticsEventWorkspace => {
  return {
    eventName: 'Workspace Updated',
    ...getWorkspaceEventProperties(workspace),
  };
};

export const workspaceViewed = (
  workspace: IAnalyticsWorkspaceArgument,
): IAnalyticsEventWorkspace => {
  return {
    eventName: 'Workspace Viewed',
    ...getWorkspaceEventProperties(workspace),
  };
};
